import { Capacitor } from '@capacitor/core';

/**
 * True inside the store app (the Capacitor shell that loads this same site),
 * false in every browser.
 *
 * This is the switch that keeps every price and every checkout OUT of the
 * store app. Google Play does not accept merchants based in Georgia
 * (DECISIONS 2026-09-21), so the Android app cannot sell through Play
 * Billing — and Play's payments policy forbids leading people from inside the
 * app to any other way to pay. So inside the app there is no price, no
 * checkout, no card, and no link to the website's checkout. People subscribe
 * on fluent.ge in a browser and sign in to the app with the same account.
 *
 * A screen that sells or manages payment must ask this first. Forgetting one
 * is not a bug a tester would notice — it is a policy violation a reviewer
 * would, on a developer account with no history.
 */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}
